import Link from 'next/link'
import NoResult from '../no-results'
import dayjs from 'dayjs'

export default function UserEventsTable({
    events,
}: Readonly<{
    events: [{ id: string; title: string; startDate: string }] | null
}>) {
    return (
        <div className="grid grid-cols-1 gap-2 text-lg border border-black p-3">
            <p className="text-xl font-bold">Eventi prenotati</p>
            {(events === null || events.length < 1) && <NoResult />}
            {events != null && events.length >= 1 && (
                <ul className="max-h-[330px] overflow-y-scroll">
                    {events.map((item) => (
                        <li key={item.id}>
                            <Link
                                className="my-2 flex w-full items-center justify-between gap-4"
                                key={item.id} 
                                href={`/events/${item.id}`}
                            >
                                <i className="bi-calendar relative text-4xl">
                                <p className="absolute top-2 w-full text-center text-xl font-bold not-italic">
                                    {dayjs(item.startDate).format('D')}
                                </p>
                                </i>
                                <p className="flex w-full justify-self-start truncate">
                                    {item.title}
                                </p>
                                <div>
                                    <i className="bi-arrow-up-right-circle text-3xl text-[#E9A242]" />
                                </div>
                            </Link>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    )
}
